<template>
  <div class="heatmap-sample" :class="device"></div>
</template>

<script>

export default {
  name: 'HeatmapSample',
  props: {
    device: {
      type: String,
      default: 'desktop'
    }
  }
}
</script>

<style lang="scss" scoped>
.heatmap-sample {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: top center;
  border-radius: 8px;

  animation-duration: 18s;
  animation-iteration-count: infinite;
  opacity: 0.7;
  &.desktop {
    animation-name: heatmap-sample-desktop;
  }
  &.tablet {
    animation-name: heatmap-sample-tablet;
  }
  &.phone {
    animation-name: heatmap-sample-phone;
  }
  &.all {
    border-radius: 100%;
    animation-name: heatmap-sample-desktop;
  }
}

@keyframes heatmap-sample-desktop {
  0% {
    background-image: url("../../assets/img/heatmap/heatmap_660_414_a.png");
  }
  33% {
    background-image: url("../../assets/img/heatmap/heatmap_660_414_b.png");
  }
  66% {
    background-image: url("../../assets/img/heatmap/heatmap_660_414_c.png");
  }
  100% {
    background-image: url("../../assets/img/heatmap/heatmap_660_414_a.png");
  }
}
@keyframes heatmap-sample-tablet {
  0% {
    background-image: url("../../assets/img/heatmap/heatmap_405_546_a.png");
  }
  33% {
    background-image: url("../../assets/img/heatmap/heatmap_405_546_b.png");
  }
  66% {
    background-image: url("../../assets/img/heatmap/heatmap_405_546_c.png");
  }
  100% {
    background-image: url("../../assets/img/heatmap/heatmap_405_546_a.png");
  }
}
@keyframes heatmap-sample-phone {
  0% {
    background-image: url("../../assets/img/heatmap/heatmap_318_522_a.png");
  }
  33% {
    background-image: url("../../assets/img/heatmap/heatmap_318_522_a.png");
  }
  66% {
    background-image: url("../../assets/img/heatmap/heatmap_318_522_a.png");
  }
  100% {
    background-image: url("../../assets/img/heatmap/heatmap_318_522_a.png");
  }
}
</style>
